var exports = {
  "E": "ActionMenuButton__1Y_4Bf",
  "S": "subscriptionDialog__3KsIIz",
};

module.exports = exports;
